function htmlEscape(str) {
  return str
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
}

const config = {
  chartId: 'id',
  credits: { enabled: false },

  // colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
  // 	'#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],

  chart: {
    type: 'column'
  },

  title: {
    text: ''
  },

  xAxis: {
    categories: [],
    title: {
      text: ''
    }
  },

  yAxis: {
    title: {
      text: ''
    }
  },

  tooltip: {
    headerFormat: '<b>{series.name} for {point.x} </b><br/>',
    pointFormat: '{point.y}',
    formatter: function() {
      return `
        <div>
          <b>${this.series.name} for ${htmlEscape(this.x)}</b>
          <br />
          ${this.y}
        </div>`;
    }
  },

  plotOptions: {
    column: {
      stacking: 'normal'
    }
  },

  series: []
};

export default config;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartBarConfig.js